import { render, staticRenderFns } from "./SupportedCards.vue?vue&type=template&id=71590309&scoped=true"
import script from "./SupportedCards.vue?vue&type=script&lang=js"
export * from "./SupportedCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71590309",
  null
  
)

export default component.exports